import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-currency-value',
  templateUrl: './currency-value.component.html'
})
export class CurrencyValueComponent {

  @Input() id: string;
  @Input() value: string;

  constructor() { }
}
